/* eslint-disable no-param-reassign */
// redux toolkit provides immutability under the hood

import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

// List of items that rely on this DirtyState pattern
export enum DirtyStateItems {
    LibraryAddLabelForm = 'LibraryAddLabelForm',
    MeetingDetailsForm = 'MeetingDetailsForm',
    MembersGroupForm = 'MembersGroupForm',
    MembersMemberForm = 'MembersMemberForm',
    MinutesEditor = 'MinutesEditor',
    RoomSettings = 'RoomSettings',
    TaskDetailForm = 'TaskDetailForm',
    TopicDocumentsForm = 'TopicDocumentsForm',
    TopicForm = 'TopicForm'
}

type DirtyStateItemProperties = {
    isModalVisible?: boolean;
    isDirty?: boolean;
};

type DirtyStateItemsObject = {
    [key in DirtyStateItems]: DirtyStateItemProperties;
};

type DirtyStateRootState = {
    items: DirtyStateItemsObject;
};

const initialState: DirtyStateRootState = {
    items: {
        MeetingDetailsForm: {},
        MembersMemberForm: {},
        MembersGroupForm: {},
        RoomSettings: {},
        TaskDetailForm: {},
        TopicDocumentsForm: {},
        TopicForm: {},
        LibraryAddLabelForm: {},
        MinutesEditor: {}
    }
};

const dirtyStateSlice = createSlice({
    name: 'dirtyState',
    initialState,
    reducers: {
        showItem(state, action: PayloadAction<DirtyStateItems>) {
            state.items[action.payload].isModalVisible = true;
        },
        hideItem(state, action: PayloadAction<DirtyStateItems>) {
            state.items[action.payload].isModalVisible = false;
        },
        setItemDirtiness(
            state,
            action: PayloadAction<{ item: DirtyStateItems; isDirty: boolean }>
        ) {
            state.items[action.payload.item].isDirty = action.payload.isDirty;
        }
    }
});

export default dirtyStateSlice.reducer;

// Action creators
export const { showItem, hideItem, setItemDirtiness } = dirtyStateSlice.actions;

// Selectors

export const getDirtyStateItems = (state: any) => state?.dirtyState?.items as DirtyStateItemsObject;
export const getDirtyStateItemProperties = (item: DirtyStateItems) => (state: any) =>
    state?.dirtyState?.items[item] as DirtyStateItemProperties;
